import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, brands } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { getIntro } from "../services";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [intro, setIntro] = useState([]);
  useEffect(() => {
    getIntro()
      .then((result) => {
        setIntro(result);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <div>
      {loading ? (
        <div className="load flex items-center justify-center">
          <div className="w-16 h-16 border-4 border-white border-solid rounded-full animate-spin"></div>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <section className="flex lg:flex-row h-4/5">
            <div className="mt-32 px-5 w-full md:px-10 lg:px-10 xl:px-20 lg:mt-20 xl:mt-32 lg:w-1/2">
              <h1 className="text-3xl font-semibold">Hi, I'm Kelvin 👋</h1>
              <p className="mt-5 text-lg">{intro[0].intro}</p>

              <a
                href={intro[0].resume.url}
                target="blank"
                className="w-fit hover:bg-white hover:text-black font-semibold block mt-10 text-lg border border-solid rounded-xl border-white px-6 py-2"
              >
                My Resume
              </a>

              <Link
                to="/portfolio"
                className="hover:bg-white hover:text-black font-semibold inline-block mt-3 text-lg border border-solid rounded-xl border-white px-6 py-2"
              >
                View my work <FontAwesomeIcon icon={solid("arrow-right")} />
              </Link>

              <div className="lg:my-10 mt-20">
                <ul className="m-auto lg:m-0 flex text-center w-4/5 lg:w-1/2 justify-between place-items-center">
                  <li>
                    <a
                      href="https://github.com/princekelvx"
                      target="blank"
                      className="hover:bg-white hover:text-black block border border-solid rounded-full border-white p-4"
                      title="github profile"
                    >
                      {" "}
                      <FontAwesomeIcon icon={brands("github")} size="2x" />
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://instagram.com/prince_kelvx"
                      target="blank"
                      className="hover:bg-white hover:text-black block border border-solid rounded-full border-white p-4"
                      title="instagram profile"
                    >
                      {" "}
                      <FontAwesomeIcon icon={brands("instagram")} size="2x" />
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://twitter.com/prince_kelvx"
                      target="blank"
                      className="hover:bg-white hover:text-black block border border-solid rounded-full border-white p-4"
                      title="twitter profile"
                    >
                      {" "}
                      <FontAwesomeIcon icon={brands("twitter")} size="2x" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </motion.div>
      )}
    </div>
  );
};

export default Home;
